export const SSPSA_FOOD_VERSION_CURRENT = 'current'
export const SSPSA_FOOD_VERSION_PREVIOUS = 'previous'
export const SSPSA_FOOD_VERSION_UPCOMING = 'upcoming'
export const SSPSA_FOOD_VERSION_PREVIEW = 'preview'

export const SSPSA_FOOD_VERSION_MESSAGES = {
  [SSPSA_FOOD_VERSION_CURRENT]: `SSPSA for the ${SSPSA_FOOD_VERSION_CURRENT} cycle not available.`,
  [SSPSA_FOOD_VERSION_PREVIOUS]: `SSPSA for the ${SSPSA_FOOD_VERSION_PREVIOUS} cycle not available.`,
  [SSPSA_FOOD_VERSION_UPCOMING]:
    'SSPSA for the next cycle is not yet available. A first look will be available from the Thursday before plinth changeover, and then the final version will be accessible the day before.',
}

export const SSPSA_FOOD_VERSION_NO_SSPSA_GENERATED_MESSAGES = {
  [SSPSA_FOOD_VERSION_CURRENT]: `There is no Food SSPSA for the ${SSPSA_FOOD_VERSION_CURRENT} cycle for your store - your store is not ranged for any Food secondary spaces.`,
  [SSPSA_FOOD_VERSION_PREVIOUS]: `There is no Food SSPSA for the ${SSPSA_FOOD_VERSION_PREVIOUS} cycle for your store - your store is not ranged for any Food secondary spaces.`,
  [SSPSA_FOOD_VERSION_UPCOMING]: `There is no Food SSPSA for the ${SSPSA_FOOD_VERSION_UPCOMING} cycle for your store - your store is not ranged for any Food secondary spaces.`,
  [SSPSA_FOOD_VERSION_PREVIEW]: `There is no Food SSPSA for the ${SSPSA_FOOD_VERSION_PREVIEW} cycle for your store - your store is not ranged for any Food secondary spaces.`,
}

export const SSPSA_FOOD_VERSIONS = [
  SSPSA_FOOD_VERSION_UPCOMING,
  SSPSA_FOOD_VERSION_CURRENT,
  SSPSA_FOOD_VERSION_PREVIOUS,
  SSPSA_FOOD_VERSION_PREVIEW,
]
